module.exports = __webpack_public_path__ + "2cc77d629051791ef916c5c83b6d1cb8.svg";